// Carry Roll HelpPanel — per-parameter tutorials/help (11.8).

const HELP_ITEMS: { param: string; text: string }[] = [
  { param: 'Ball speed', text: 'The speed of the ball immediately after impact. The biggest driver of carry distance.' },
  { param: 'Launch angle', text: 'Vertical angle of the ball at launch. Optimal driver launch is 10–16°.' },
  { param: 'Spin rate', text: 'Backspin in RPM. Governs lift, hang time, and landing angle.' },
  { param: 'Spin axis', text: 'Tilt of the spin axis in degrees. Positive fades right; negative draws/hooks left. ±2° reads as straight.' },
  { param: 'Smash factor', text: 'Ball speed ÷ club speed. Realistic range 1.00–1.55.' },
  { param: 'Carry', text: 'Distance the ball travels in the air before first landing, in your distance unit.' },
  { param: 'Roll', text: 'Ground run-out after landing. Total = carry + roll.' },
  { param: 'Apex', text: 'Peak height of the ball in flight, in your height unit.' },
  { param: 'Descent', text: 'Angle of the ball’s path at landing, in degrees. Steeper angles stop faster.' },
  { param: 'Shot shape', text: 'Classified from spin-axis tilt: straight, draw/fade, or hook/slice.' },
  { param: 'Profile', text: 'Trajectory class from apex-to-carry ratio: low, mid, or high.' },
  { param: 'Measured distance', text: 'Total distance recomputed at sea level with no wind — a neutral reference for comparing shots.' },
  { param: 'Confidence', text: 'Measured/Mixed/Assumed reflects how many key launch inputs were entered versus left at default.' },
  { param: 'Altitude', text: 'Higher altitude → thinner air → less drag → more carry.' },
  { param: 'Wind', text: 'Headwind (0°) costs distance; tailwind (180°) adds it; crosswind shifts finish.' },
  { param: 'Firmness', text: 'Ground firmness. Firm = more roll; soft = less roll.' },
  { param: 'Landing surface', text: 'Where the ball first lands. Green and rough grip more than fairway.' },
  { param: 'Flight-model fidelity', text: 'Full integrates drag, lift, and spin decay step-by-step (accurate). Basic uses a closed-form reduced model (fast, approximate).' },
];

export function HelpPanel() {
  return (
    <div data-testid="help-panel">
      <h3 className="subsection-title">
        Help &amp; tutorials
      </h3>
      <dl className="text-sm">
        {HELP_ITEMS.map((h) => (
          <div key={h.param} style={{ padding: 'var(--space-2)', borderBottom: '1px solid var(--color-border)' }}>
            <dt style={{ color: 'var(--color-accent)', fontWeight: 'var(--fw-medium)' }}>{h.param}</dt>
            <dd style={{ color: 'var(--color-text-muted)' }}>{h.text}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
